
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-difference",
      function () {
        return require("private-next-pages/our-difference/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-difference"])
      });
    }
  